import React, { useState } from "react";
import axios from "axios";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { BasicForm } from "@components/shared";

export default function NoteForm({ reqData = {}, onSuccess }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(false);

  function onSubmit(formData) {
    setLoading(true);

    return onCreate(formData);
  }

  function onCreate(formData) {
    const req = {
      ...reqData,
      ...formData,
    };

    axios
      .post(`/notes/`, req)
      .then(({ data }) => {
        onSuccess();
        toast.success(t("created"));
        setReset(true);
        setTimeout(() => {
          setReset(false);
        }, 1);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "subject",
      label: t("subject"),
      initialValue: "",
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "message",
      label: t("note_singular"),
      initialValue: "",
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
      textarea: true,
    },
    {
      name: "admin_only",
      label: "Admin Only",
      initialValue: "",
      toggle: true,
      schema: () => null,
    },
  ];

  return (
    <div>
      {!reset && (
        <BasicForm
          loading={loading}
          onSubmit={onSubmit}
          fields={fields}
          buttonProps={{
            fullWidth: true,
          }}
        />
      )}
    </div>
  );
}
